import React from 'react';

import { parseImperialLengthSummationExpression } from '@paragon/client-tools';

import { useActiveDistanceFormatter } from './DistanceFormattingContext';
import { NumericField, NumericFieldProps } from './NumericField';

type PartialPartial<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export type DistanceFieldProps<
  TAllowNull extends boolean = false,
  TAllowNullSubmittal extends boolean = false,
  TAllowIndeterminate extends boolean = false,
> = PartialPartial<
  NumericFieldProps<TAllowNull, TAllowNullSubmittal, TAllowIndeterminate>,
  'formatValue' | 'parseValue'
>;

export function DistanceField<
  TAllowNull extends boolean = false,
  TAllowNullSubmittal extends boolean = false,
  TAllowIndeterminate extends boolean = false,
>(props: DistanceFieldProps<TAllowNull, TAllowNullSubmittal, TAllowIndeterminate>) {
  const formatLength = useActiveDistanceFormatter();

  return (
    <NumericField<TAllowNull, TAllowNullSubmittal, TAllowIndeterminate>
      formatValue={formatLength}
      parseValue={(input) => {
        const result = parseImperialLengthSummationExpression(input);
        return result !== null ? { valid: true as const, value: result } : { valid: false as const };
      }}
      {...props} // spread after format-related props to allow overriding
    />
  );
}
